<template>
  <div class="page-column">
    <Header :type="true"/>
<!--    <div style="width: 100%; min-height: 100%; background-color: rgb(250, 250, 250)">-->
<!--      -->
<!--    </div>-->
    <div class="content-warp content-top">
      <Join ref="join"></Join>
    </div>
  </div>
</template>
<script>
import Header from '@district/components/common/MatchHeader.vue'
import Join from '@comm/components/join/Join.vue'
export default {
  name: 'matchJoin',
  components: {
    Header,
    Join
  },
  mounted () {
  },
}
</script>
<style lang="scss" scoped>
  .page-column {
   width: 100%;
  }
  .content-warp {
    width: 1200px;
    margin: 0 auto;
  }
  .content-top {
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/district/views/project/components/Join.vue